import React from 'react';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './AdminUser.css';

// Component
import AdminUserManagement from '../../../components/siteadmin/AdminUserManagement';

const AdminUser = () => {

  return <AdminUserManagement
  />;
}

export default compose(withStyles(s))(AdminUser);

